import React, { useState } from 'react';
import GridApiContext, { ExcelExport } from './GridApiContext';
import { DEFAULT_GRID_EXPORT_STATE } from './helpers';
import { useSelectSecondaryBudgetAxisSourceTable } from 'routes/BudgetModule/components/BudgetWithProvider/SecondaryBudgetAxisSourceTableContext';

const GriApiProvider = ({ children }: { children: React.ReactNode }) => {
    // GRID CONTEXT
    const sourceTable = useSelectSecondaryBudgetAxisSourceTable();
    const gridApiState = useState<{ [key: string]: ExcelExport }>(
        DEFAULT_GRID_EXPORT_STATE(sourceTable),
    );
    return (
        <GridApiContext.Provider value={gridApiState}>
            {children}
        </GridApiContext.Provider>
    );
};

export default React.memo(GriApiProvider);
